import {
	validateSignUpAccessCode,
	ValidateSignUpAccessCodePayload,
	ValidateSignUpAccessCodeResponse,
} from "@/api/register";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export default function useValidateSignUpAccessCode(
	options?: MutationOptionsWithoutFn<
		ValidateSignUpAccessCodeResponse,
		ValidateSignUpAccessCodePayload
	>,
) {
	return useMutation({
		...options,
		mutationFn: validateSignUpAccessCode,
	});
}
